import moment from "moment";
import React, { useEffect } from "react";
import { useDetallePaletizacion } from "../hooks/useDetallePaletizacion";
import LoadMask from "Utils/LoadMask/LoadMask";
import { ListadoPallets } from "./ListadoPallets/ListadoPallets";
import { MetricasPaletizacion } from "../../../../components/MetricasPaletizacion/MetricasPaletizacion";

export const PaletizacionForm = ({ idPaletizacion, regresar }) => {
    const {
        pallets,
        metricasPaletizacion,
        fueAtendidoPorBodega,

        cargando,
    } = useDetallePaletizacion(idPaletizacion, regresar);

    return (
        <LoadMask loading={cargando} blur>
            <MetricasPaletizacion
                metricasPaletizacion={metricasPaletizacion}
                mode="sin_paletizar"
            />

            <ListadoPallets
                pallets={pallets}
                fueAtendidoPorBodega={fueAtendidoPorBodega}
            />
            <MetricasPaletizacion
                metricasPaletizacion={metricasPaletizacion}
                mode="paletizado"
            />

            <div className="d-flex justify-content-center mt-3 gap-2rem">
                <button className="btn btn-outline-dark" onClick={regresar}>
                    Regresar
                </button>
            </div>
        </LoadMask>
    );
};
